module.exports = __webpack_public_path__ + "static/media/who-21.34e623cd.jpg";